export const name = '_cardano'
export const displayName = 'Cardano'
export const ticker = `${name}_ADA`
export const displayTicker = 'ADA'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 6,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = ['cardano', 'ada_bsc_db5f96ab']
